import register from '../register';

register( 'hero-carousel', function() {

  let container = document.querySelector('.station-detail .carousel-images');
  let arrows = document.querySelectorAll('.station-detail .arrows__arrow');
  let dots = document.querySelectorAll('.station-detail .hero-carousel__dot');
  let forEach = Array.prototype.forEach;
  /*eslint-disable */
  let images = document.querySelectorAll(
    '.station-detail .hero-carousel__station'
  );
  /*eslint-enable */
  let numImages = images.length;
  let currentIndex = 0;

  function getModifier( elem ) {
    return parseInt( elem.dataset.modifier );
  }

  function slideTo( container, index ) {
    container.dataset.index = index;
  }

  function changeIndex( currentIndex, modifier ) {
    return Math.max( 0, Math.min( currentIndex += modifier, numImages - 1 ) );
  }

  function updateDot( dots, oldIndex, newIndex ) {
    dots[ oldIndex ].dataset.active = false;
    dots[ newIndex ].dataset.active = true;
  }

  function onArrowClick( ev ) {
    let modifier = getModifier( ev.currentTarget );
    let oldIndex = currentIndex;

    currentIndex = changeIndex( currentIndex, modifier );
    updateDot( dots, oldIndex, currentIndex );
    slideTo( container, currentIndex );
  }

  forEach.call( arrows, function( elem ) {
    elem.addEventListener( 'click', onArrowClick );
  });

});

export default undefined;
